import React, { useEffect, useState } from "react";
import {
  default as ReactCamera,
  FACING_MODES,
  IMAGE_TYPES
} from "react-html5-camera-photo";
import { Box, makeStyles, CircularProgress } from "@material-ui/core";
import "react-html5-camera-photo/build/css/index.css";
import { Alert } from "@material-ui/lab";

const useClasses = makeStyles(theme => ({
  cameraContainer: {
    "& video": {
      maxWidth: "100%"
    },
    "& img": {
      maxWidth: "100%"
    },
    "& #container-circles": {
      zIndex: 200
    },
    "& #inner-circle": {
      backgroundColor: theme.palette.primary.main
    }
  },
  lastphoto: {
    maxWidth: "100%"
  },
  cameraMask: {
    position: "relative"
  },
  cameraMaskClip: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    height: "20%",
    zIndex: 100,
    backgroundColor: theme.palette.common.black
  },
  cameraMaskClipBottom: {
    top: "auto",
    bottom: 0
  },
  cameraViewfinder: {
    position: "absolute",
    top: "22%",
    bottom: "22%",
    height: "56%",
    left: "2%",
    right: "2%",
    zIndex: 100,
    boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`
  }
}));

const CameraMask = ({ children }) => {
  const classes = useClasses();

  return (
    <Box className={classes.cameraMask}>
      <Box className={classes.cameraMaskClip}></Box>
      <Box
        className={`${classes.cameraMaskClip} ${classes.cameraMaskClipBottom}`}
      ></Box>
      <Box className={classes.cameraViewfinder}></Box>
      {children}
    </Box>
  );
};

const CAMERA_ACCESS_NOT_CHECKED = "not checked";
const CAMERA_ACCESS_CHECKED_NO_ACCESS = "no access";
const CAMERA_ACCESS_CHECKED_SUCCESS = "success";

const Camera = ({ photo, onTakePhoto, ...rest }) => {
  const classes = useClasses();
  const [hasCameraAccess, setHasCameraAccess] = useState(
    CAMERA_ACCESS_NOT_CHECKED
  );

  useEffect(() => {
    const getMedia = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });

        if (stream.active && stream.id)
          setHasCameraAccess(CAMERA_ACCESS_CHECKED_SUCCESS);
      } catch (err) {
        setHasCameraAccess(CAMERA_ACCESS_CHECKED_NO_ACCESS);
      }
    };

    getMedia();
  }, []);

  return (
    <Box className={classes.cameraContainer}>
      <CameraMask>
        {photo ? (
          <Box>
            <img className={classes.lastphoto} src={photo} />
          </Box>
        ) : (
          <>
            {hasCameraAccess === CAMERA_ACCESS_NOT_CHECKED && (
              <Box textAlign="center">
                <CircularProgress />
              </Box>
            )}
            {hasCameraAccess === CAMERA_ACCESS_CHECKED_SUCCESS && (
              <ReactCamera
                className={classes.camera}
                onTakePhotoAnimationDone={dataUri => onTakePhoto(dataUri)}
                idealFacingMode={FACING_MODES.ENVIRONMENT}
                isImageMirror={false}
                imageType={IMAGE_TYPES.JPG}
                {...rest}
              />
            )}
            {hasCameraAccess === CAMERA_ACCESS_CHECKED_NO_ACCESS && (
              <Alert color="info">We cannot access your camera.</Alert>
            )}
          </>
        )}
      </CameraMask>
    </Box>
  );
};

export { Camera };
